/* eslint-disable no-useless-constructor */
import { Component } from "react";
// import { sanitize } from 'dompurify';
import DOMPurify from "dompurify";
const sanitize = DOMPurify.sanitize;

const normalFontSize = "12px"
const titleFontSize = "15px"
const questionFontSize = '14px'
class GenAIAnsweringHTMLNotebook extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projectName: (props.projectName) ? props.projectName : '',
            projectType: (props.projectType) ? props.projectType : '',
            chatConversation: (props.chatConversation) ? props.chatConversation : '',
        }
    }
    componentWillMount() {
    }
    renderQuestionAnswer = () => {
        const { chatConversation } = this.state
        return (<>
        
            {chatConversation.map((conversation, index) => {
                let { Question, OutputAnswer , DisplayStringMultiFiles , SourcesMultiFiles } = conversation;
                if (DisplayStringMultiFiles.length < 1 && OutputAnswer === "We don't know the answer. Can you try new questions.") {
                OutputAnswer = `No Answer found. Please try a new question.`;
            }
                return (<>
                    <div
                        style={{
                            width: "100%",
                            background: "#fff",
                            textAlign: "left",
                            margin: '10px 5px'
                        }}
                        className="nb-main-title"
                    >
                        <p style={{
                            wordBreak: "break-word",
                            fontSize: questionFontSize,
                            fontWeight: 'bold',
                            color: "black",
                            margin: "3px",
                            fontFamily: "Verdana",
                            display: "inline",
                        }}>
                            {Question}
                        </p>
                    </div>
                    {(( DisplayStringMultiFiles.length > 0) ? SourcesMultiFiles.map((smitem, smindex) => {
                        let filterDisplayStringMultiFiles = DisplayStringMultiFiles.filter(x => x.source_no.includes(smindex + 1));
                        return (
                            filterDisplayStringMultiFiles.map((dsitem , dsindex)=>{
                                return(
                                    <><div
                                style={{
                                    width: "100%",
                                    background: "#fff",
                                    textAlign: "left",
                                    margin: '10px 5px'
                                }}
                                className="nb-main-title"
                            >
                                <div style={{
                                    wordBreak: "break-word",
                                    fontSize: normalFontSize,
                                    fontWeight: '400',
                                    color: "black",
                                    margin: "3px",
                                    fontFamily: "Verdana",
                                    display: "inline",
                                }}>
                                    <span dangerouslySetInnerHTML={{ __html: sanitize(`${dsitem.display_ans}`) }} />
                                </div>
                            </div></>
                                )
                            })
                            )
                    }) : <>
                        <div
                            style={{
                                width: "100%",
                                background: "#fff",
                                textAlign: "left",
                                margin: '10px 5px'
                            }}
                            className="nb-main-title"
                        >
                            <div style={{
                                wordBreak: "break-word",
                                fontSize: normalFontSize,
                                color: "black",
                                margin: "3px",
                                fontFamily: "Verdana",
                                display: "inline",
                            }}>
                                <span dangerouslySetInnerHTML={{ __html: sanitize(`${OutputAnswer}`) }} />
                            </div>
                        </div>
                    </>)
                    }

                </>)
            }
            )}
            
            </>)
    }
    renderDates = () => {
        const date = new Date();
        return (`${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`)
    }
    renderHeading = () => {
        const { projectName, projectType } = this.state
        return (
            <div style={{ width: '100%', border: '1px solid #d8d8cf80' }}>
                <div style={{ width: "100%", alignItems: "center", fontSize: titleFontSize, fontFamily: "Verdana", color: '#eb1600', padding: '10px 20px' }}>
                    <b style={{ paddingRight: '14px' }}><label>Project Name:</label> {projectName}</b>
                </div>
                <div style={{ width: "100%", alignItems: "center", fontSize: titleFontSize, fontFamily: "Verdana", color: '#eb1600', padding: '10px 20px' }}>
                    <b style={{ paddingRight: '14px' }}><label>Project Type:</label> {projectType}</b>
                </div>
            </div>
        )
    }
    render() {
        return (
            <div style={{ width: "100%" }}>
                {this.renderHeading()}
                {this.renderQuestionAnswer()}
            </div>
        );
    }

}
export default GenAIAnsweringHTMLNotebook;